import { render, staticRenderFns } from "./VFooterEKG.vue?vue&type=template&id=448078b4&"
import script from "./VFooterEKG.vue?vue&type=script&lang=js&"
export * from "./VFooterEKG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports